import { render, staticRenderFns } from "./TariffGroups.vue?vue&type=template&id=102b3b2f"
import script from "./TariffGroups.vue?vue&type=script&lang=js"
export * from "./TariffGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports